// The remaining OAuth-family connectors — every provider whose `authFamily` is neither Google,
// Meta nor TikTok. One provider per family, so each entry lands with its own family port.
//
// `category` is copied verbatim from v3 and is not always what the name suggests: Reddit is filed
// under `organic_social` and Pinterest under `analytics_and_tracking` (`utils/integrations.js:560,
// 612`) while every other ad platform here is `paid_advertising`. Preserved — the Connections page
// tab a connector appears under is product data, not a transcription slip to "fix".

import type { IntegrationProvider } from '../providers.types'

export const SOCIAL_PROVIDERS: readonly IntegrationProvider[] = [
  {
    key: 'criteo_account',
    id: 'criteo_account',
    nameKey: 'integrations.providers.criteo',
    category: 'paid_advertising',
    authFamily: 'criteo_oauth',
    connect: 'oauth',
    configComponent: () => import('../../components/connectors/SocialAccountConnector.vue'),
    labelFields: ['advertiser_name', 'advertiser_id'],
    logo: 'criteo',
  },
  {
    key: 'snapchat_account',
    id: 'snapchat_account',
    nameKey: 'integrations.providers.snapchat',
    category: 'paid_advertising',
    authFamily: 'snapchat_oauth',
    connect: 'oauth',
    configComponent: () => import('../../components/connectors/SocialAccountConnector.vue'),
    labelFields: ['name'],
    logo: 'snapchat_ads',
  },
  {
    key: 'linkedin_ads_account',
    id: 'linkedin_ads_account',
    nameKey: 'integrations.providers.linkedin',
    category: 'paid_advertising',
    authFamily: 'linkedin_oauth',
    connect: 'oauth',
    configComponent: () => import('../../components/connectors/SocialAccountConnector.vue'),
    labelFields: ['name', 'linkedin_account_id', 'account_id'],
    logo: 'linkedin_ads',
  },
  {
    key: 'twitter_ad_account',
    id: 'twitter_ad_account',
    nameKey: 'integrations.providers.twitter',
    category: 'paid_advertising',
    authFamily: 'twitter_auth',
    connect: 'oauth',
    configComponent: () => import('../../components/connectors/SocialAccountConnector.vue'),
    labelFields: ['account_id', 'name'],
    logo: 'twitter',
  },
  {
    key: 'yandex_direct_account',
    id: 'yandex_direct_account',
    nameKey: 'integrations.providers.yandexAds',
    category: 'paid_advertising',
    authFamily: 'yandex-oauth',
    connect: 'oauth',
    configComponent: () => import('../../components/connectors/SocialAccountConnector.vue'),
    labelFields: ['client_info', 'client_id'],
    logo: 'yandex',
  },
  {
    key: 'reddit_ad_account',
    id: 'reddit_ad_account',
    nameKey: 'integrations.providers.reddit',
    category: 'organic_social',
    authFamily: 'reddit_oauth',
    connect: 'oauth',
    configComponent: () => import('../../components/connectors/SocialAccountConnector.vue'),
    labelFields: ['name'],
    logo: 'reddit',
  },
  {
    key: 'bing_ads_account',
    id: 'bing_ads_account',
    nameKey: 'integrations.providers.bing',
    category: 'paid_advertising',
    authFamily: 'bing_oauth',
    connect: 'oauth',
    configComponent: () => import('../../components/connectors/SocialAccountConnector.vue'),
    labelFields: ['account_name', 'account_id'],
    logo: 'bing_ads',
  },
  {
    key: 'pinterest_account',
    id: 'pinterest_account',
    nameKey: 'integrations.providers.pinterest',
    category: 'analytics_and_tracking',
    authFamily: 'pinterets_oauth',
    connect: 'oauth',
    configComponent: () => import('../../components/connectors/SocialAccountConnector.vue'),
    labelFields: ['name'],
    logo: 'pinterest',
  },
]
